var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1473 447L1473 475",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1473.5,
    cy: 442.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1468.99 442.19C1468.99 438.283 1472.29 435.117 1476.36 435.117C1476.94 435.117 1477.51 435.184 1478.06 435.308C1476.74 434.48 1475.19 434 1473.52 434C1468.81 434 1465 437.806 1465 442.5C1465 447.194 1468.81 451 1473.52 451C1475.81 451 1477.89 450.093 1479.43 448.62C1478.49 449.032 1477.45 449.263 1476.36 449.263C1472.29 449.263 1468.99 446.096 1468.99 442.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1482.4 441.6L1482.37 439.146L1480.54 440.719L1478.3 440.056L1479.11 442.337L1477.77 444.381L1480.1 444.218L1481.5 446.144L1482.13 443.763L1484.34 442.909L1482.4 441.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch2);
export default __webpack_public_path__ + "static/media/church_2.3073c0fa02e23cde2e1d6314da627d9f.svg";
export { ForwardRef as ReactComponent };